import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    root: {
        height: "100vh"
    },
    wrapButton:{
        display:"flex",
        justifyContent:"center",
        paddingBottom:"70px",
        marginTop:"50px"
    },
    listPadding: {
        paddingBottom: 0,
      },
      list: {
        backgroundColor: "#EFF1FF",
      },
    wrapPengaturan:{
        paddingTop:"60px",
        marginBottom: "20px"
    },
    btnTokoSaya:{
        display:"flex",
        marginBottom:"40px",
        justifyContent: "center"
    },
    large: {
        width: 80,
        height: 80,
        border:"2px solid #5675D3"
      },
    content: {
        marginTop: "15px",
        width: "100%",
        position: "relative"
    }
}))

export default useStyles
